"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[935,1550,2303,2362,2773,3566,4982,5383,7065,7774,8569,9822],{

/***/ 935:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ elementsExist)
/* harmony export */ });
function elementsExist(elements = []) {
  return elements.filter((el) => el.length).length == elements.length
}


/***/ }),

/***/ 1550:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ disableScroll)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function disableScroll() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).addClass('overflow-hidden')
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').addClass('overflow-hidden')
}


/***/ }),

/***/ 2303:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ showToastNotification)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function showToastNotification(message, url, status = 'warning') {
  const $toastContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-registry-wishlist-toast-container]')
  const bgColor = {
    success: 'bg-successGreen',
    warning: 'bg-moon',
    error: 'bg-errorPink',
  }

  const $toast = jquery__WEBPACK_IMPORTED_MODULE_0___default().parseHTML(`<div
      class="animate-fadeInUp animate-duration-[800ms] text-base font-galano font-bold text-galaxt leading-none rounded ${
        bgColor[status]
      } shadow-sm py-4 px-5 mx-auto flex items-center justify-center gap-2 transition-all w-full max-w-[calc(100vw_-_32px)] lg:max-w-[600px]"
    >
      ${
        status === 'success'
          ? `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12.3333 7L7.75 11.5833L5.66666 9.5" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>      
      `
          : `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 1C13.4183 1 17 4.58172 17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1Z" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 5.79996V9.66663" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 12.2H9.01067" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `
      }
      <span>${message}${
    url && url !== '' ? ` - <a href="${url}" class="text-galaxy underline hover:no-underline">View</a></span>` : ''
  }
    </div>`)

  $toastContainer.append($toast)
  const $toastNode = $toastContainer.children().last()

  setTimeout(function () {
    $toastNode.removeClass('animate-fadeInUp').addClass('animate-fadeOutDown')
    setTimeout(function () {
      $toastNode.remove()
    }, 500)
  }, 3500)
}


/***/ }),

/***/ 2362:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ trapFocus)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
 * * Traps user focus within a wrapper when the wrapper is `active`
 * @param { HtmlElement } wrapper
 *
 * @example
 *  <div data-utility="trap-focus">
 *  ...
 *  </div>
 */

function trapFocus({ wrapper }) {
  const { classes } = window.config

  const state = {
    focusOnReturnEl: undefined, // The element to focus on close
  }

    ; (function init() {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('keydown', handleKeydown)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).onClassChange(classes.active, updateFocus)
    })()

  function handleKeydown(event) {
    const { target, key, shiftKey } = event

    // Comparison is only necesssary if the wrapper is active
    const wrapperIsActive = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)
    if (!wrapperIsActive) return

    // Handle Escape key to close modal
    if (key === 'Escape') {
      // Trigger a custom event that the modal can listen for
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).trigger('modal:close')
      return
    }

    // Handle Tab key for focus trapping
    if (key !== 'Tab') return

    const $focusable = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).findFocusable()
    const $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(target)

    const tabbingOutForwards = $target.is($focusable.last()) && !shiftKey
    const tabbingOutBackwards = $target.is($focusable.first()) && shiftKey

    if (tabbingOutForwards || tabbingOutBackwards) event.preventDefault()

    if (tabbingOutBackwards) $focusable.last().trigger('focus')
    if (tabbingOutForwards) $focusable.first().trigger('focus')
  }

  // Focuses on the correct element when the wrapper changes `active` states
  function updateFocus() {
    const wrapperIsActive = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)
    const $focusable = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).findFocusable()

    // Set focus on the first focusable element within the wrapper
    if (wrapperIsActive) {
      state.focusOnReturnEl = state.focusOnReturnEl || document.activeElement
      $focusable.first().trigger('focus')
    }

    // Return focus to the element that originally opened the wrapper
    if (!wrapperIsActive && state.focusOnReturnEl) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(state.focusOnReturnEl).trigger('focus')
      state.focusOnReturnEl = undefined
    }
  }
}


/***/ }),

/***/ 2380:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Cart)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utilities_toastNotification_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3566);
/* harmony import */ var _product_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4559);




const Product = (0,_product_page__WEBPACK_IMPORTED_MODULE_2__["default"])()

function enableScroll() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).removeClass('overflow-hidden')
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').removeClass('overflow-hidden')
}

function disableScroll() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).addClass('overflow-hidden')
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').addClass('overflow-hidden')
}

function Cart() {
  const urls = {
    cartUpdate: '/cart/update.js',
    cartChange: '/cart/change.js',
    cartAdd: '/cart/add.js',
    cartGet: '/cart.json',
  }

  const settings = {
    slideCartContainer: '.js-cart--container',
    slideCartInner: '.js-cart--inner',
    closeCart: '.js-cart--close',
    openCart: "a[href='/cart']",
    removeItem: '.js-cart--remove-item',
    itemQuantity: '.js-item-quantity',
    quantityButton: '.js-change-quantity',
    productForm: "form[action='/cart/add']",
    giftOptionsExpandButton: '.js-gift-options-expand-button',
    cartNoteTextareaWrapper: '.js-cart-note-textarea-wrapper',
    cartNoteTextarea: '.js-cart-note-textarea',
    cartNoteContainer: '.js-cart-note-container',
    cartNoteToggle: '.js-cart-note-toggle',
    cartNoteBadge: '.js-cart-note-badge',
    cartNoteChevron: '.js-cart-note-chevron',
    cartRegistryToggle: '.js-cart-registry-shipping-toggle',
    checkoutButton: '.js-process-checkout',
    cartOverlay: '.js-cart--overlay',
    cartGiftBagCheckbox: '.js-cart-gift-bag-checkbox',
    cartItem: '.js-cart-item',
    lemonadeStandBar: '.slide-cart--lemonade-stand-bar',
    cartUpsellProductForm: '.js-cart-upsell-form',
    lineItemPriceContainer: '[data-line-item-price-container]',
    lineItemPrice: '[data-line-item-price]',
    lineItemCompareAtPrice: '[data-compare-at-price]',
    cartDiscountToggle: '[data-cart-discount-toggle]',
    cartDiscountContainer: '[data-cart-discount-container]',
    cartDiscountInput: '[data-cart-discount-input]',
    cartDiscountSubmit: '[data-cart-discount-submit]',
    cartDiscountTag: '[data-cart-discount-tag]',
    cartDiscountTagText: '[data-cart-discount-tag-text]',
    cartDiscountButtonText: '[data-cart-discount-button-text]',
    cartRemoveDiscountButton: '[data-cart-discount-remove-button]',
    cartDiscountPlusVerticalLine: '.js-discount-plus-vertical-line',
    toastContainer: '[data-toast-container]',
    cartDisclaimer: '[data-cart-disclaimer]',
    registryTooltipButton: '[data-registry-address-tooltip]',
    registryTooltip: '[data-registry-tooltip]',
    pdpUpsellForm: '.pdp-upsell-form',
    pdpUpsellAddCheckbox: '[data-pdp-upsell-add-input]',
    pdpUpsellATC: '[data-pdp-upsell-atc]',
  }

  let $elementToFocusOnClose = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.openCart)

  ;(function init() {
    if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).length) return

    initializeEventListeners()
    buildCart()
    setCartState()

    let currentUrl = new URL(location)
    if (currentUrl.searchParams.has('open_cart')) openCart()
  })()

  function initializeEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('click', settings.removeItem, handleItemRemove)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('click', settings.checkoutButton, processCheckout)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('change', settings.itemQuantity, adjustItemQuantity)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('click', settings.quantityButton, updateItemQuantity)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('change', settings.cartNoteToggle, toggleCartNote)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('change', settings.cartNoteTextarea, updateCartNote)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('click', settings.giftOptionsExpandButton, toggleGiftOptions)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('change', settings.cartGiftBagCheckbox, toggleGiftBagInCart)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('click', settings.cartDiscountToggle, toggleDiscountCode)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('click', settings.cartDiscountSubmit, submitDiscountCode)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('click', settings.cartRemoveDiscountButton, removeDiscountCode)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).on('click', '[data-registry-address]', goToRegistryCheckout)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.registryTooltipButton, ($el) => $el.on('click', toggleToolTipOnMobile))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.registryTooltipButton, ($el) => $el.on('mouseenter focus', revealToolTipOnDesktop))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.registryTooltipButton, ($el) => $el.on('mouseleave blur', hideToolTipOnDesktop))

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('keydown', listenForEscape)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.productForm, ($el) => {
      $el.on('submit', handleProductSubmit)
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.openCart, function ($el) {
      $el.on('click', openCart)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.closeCart, function ($el) {
      $el.on('click', closeCart)
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.cartOverlay, function ($el) {
      $el.on('click', closeCart)
    })

    document.addEventListener('addBundleToCart', function () {
      buildCart()
      openCart()
    })
  }

  let state

  function getState() {
    return state
  }

  function toggleToolTipOnMobile() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    if (!isMobile) {
      return
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryTooltip).toggleClass('hidden')
  }

  function revealToolTipOnDesktop() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

    if (isMobile) {
      return
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryTooltip).removeClass('hidden')
  }

  function hideToolTipOnDesktop() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    if (isMobile) {
      return
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.registryTooltip).addClass('hidden')
  }

  function goToRegistryCheckout(e) {
    e.preventDefault()
    const urlParams = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('registry-address')
    const shipToMe = jquery__WEBPACK_IMPORTED_MODULE_0___default()('#toggle-registry-shipping').prop('checked')

    if (shipToMe === true) {
      window.location.href = this.href
    } else {
      window.location.href = this.href + urlParams
    }
  }

  function listenForEscape(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeCart(e)
    }
  }

  function setCartState() {
    getCart(function (cart) {
      state = cart
      Product.updateProductMaxQty()
      updateCartIndicator(cart)
    })
  }

  function toggleDiscountCode() {
    const $container = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountContainer)
    const $plusVerticalLine = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountPlusVerticalLine)

    if ($container.hasClass('active')) {
      $container.slideUp(300).removeClass('active')
      $plusVerticalLine.show()
    } else {
      $container.slideDown(300).addClass('active')
      $plusVerticalLine.hide()
    }
  }

  function submitDiscountCode() {
    const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const $input = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountInput)
    const code = $input.val()

    if (code) {
      $button
        .addClass('btn-disabled')
        .removeClass('btn-night transition-colors hover:bg-blush hover:color-night')
        .text('Please wait...')
        .attr('disabled', true)
      ;(0,_utilities_toastNotification_js__WEBPACK_IMPORTED_MODULE_1__["default"])('Adding discount code...')
      fetchDiscountCodeData(code, true)
    }
  }

  function resetApplyDiscountBtn() {
    const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountSubmit)
    $button
      .addClass('btn-night transition-colors hover:bg-blush hover:color-night')
      .removeClass('btn-disabled')
      .text('Apply')
      .attr('disabled', false)
  }

  function renderDiscountedPrices($newInnerHTML, cart) {
    const discount = JSON.parse(localStorage.getItem('pricingRule'))
    if (!discount) {
      return $newInnerHTML
    }

    const entitledCollections = discount.entitledCollectionIds
    const cartTotal = cart.total_price
    const minimumCartAmount =
      discount.prerequisiteSubtotalRange && parseInt(discount.prerequisiteSubtotalRange.greaterThanOrEqualTo) * 100

    if (!!minimumCartAmount && cartTotal < minimumCartAmount) {
      return $newInnerHTML
    }

    const type = discount.valueType

    if (type === 'percentage') {
      const value = Math.abs(parseInt(discount.value)) / 100
      let cartTotal = 0

      $newInnerHTML.find('[data-cart-item-price]').each(function () {
        const $productContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('[data-cart-line-item]')
        const collections = $productContainer.data('collections')
        const itemInValidCollection = entitledCollections.some((collectionId) => collections.includes(collectionId))

        const $priceContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
        const $compareAtPriceContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(settings.lineItemCompareAtPrice)

        const price = $priceContainer.data('cart-item-price')

        let discountPrice = price

        if (discount.targetType !== 'shippingLine') {
          discountPrice = price - price * value
        }

        if (entitledCollections.length > 0 && !itemInValidCollection) {
          cartTotal = cartTotal + price
          return
        }
        cartTotal = cartTotal + discountPrice

        const formattedDiscountPrice = (discountPrice / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        })

        if (price > discountPrice) {
          $compareAtPriceContainer.text($priceContainer.text())
        } else {
          $compareAtPriceContainer.text('')
        }
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).text(formattedDiscountPrice)
      })

      const $subtotalContainer = $newInnerHTML.find('[data-cart-total-price]')
      const $subtotalCompareAtContainer = $subtotalContainer.siblings('[data-cart-compare-at-price]')

      const subtotal = $subtotalContainer.data('cart-total-price')
      const formattedDiscountSubtotal = (cartTotal / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      })

      if (subtotal > cartTotal) {
        $subtotalCompareAtContainer.text($subtotalContainer.text())
      } else {
        $subtotalCompareAtContainer.text('')
      }
      $subtotalContainer.text(formattedDiscountSubtotal)
    } else if (type === 'fixedAmount') {
      const minimumCartAmount =
        discount.prerequisiteSubtotalRange && parseInt(discount.prerequisiteSubtotalRange.greaterThanOrEqualTo) * 100
      const value = Math.abs(parseInt(discount.value)) * 100
      const $subtotalContainer = $newInnerHTML.find('[data-cart-total-price]')
      const $subtotalCompareAtContainer = $subtotalContainer.siblings('[data-cart-compare-at-price]')
      const subtotal = $subtotalContainer.data('cart-total-price')
      const discountSubtotal = subtotal - value
      const formattedDiscountSubtotal = (discountSubtotal / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      })
      let validItemTotal
      if (entitledCollections.length > 0) {
        validItemTotal = 0
      } else {
        validItemTotal = subtotal
      }

      $newInnerHTML.find('[data-cart-item-price]').each(function () {
        const $productContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('[data-cart-line-item]')
        const collections = $productContainer.data('collections')
        const itemInValidCollection = entitledCollections.some((collectionId) => collections.includes(collectionId))
        const price = $productContainer.find('[data-cart-item-price]').data('cart-item-price')
        if (entitledCollections.length > 0 && itemInValidCollection) {
          validItemTotal = validItemTotal + price
          return
        }
      })

      if (!!minimumCartAmount && validItemTotal < minimumCartAmount) {
        return $newInnerHTML
      }

      if (subtotal > discountSubtotal && (validItemTotal > minimumCartAmount || !minimumCartAmount)) {
        $subtotalCompareAtContainer.text($subtotalContainer.text())
      } else {
        $subtotalCompareAtContainer.text('')
      }

      $subtotalContainer.text(formattedDiscountSubtotal)
    }

    return $newInnerHTML
  }

  async function fetchDiscountCodeData(code, showToast = false) {
    const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountSubmit)
    const $container = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountContainer)

    if (code === 'COZY') {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDisclaimer).show()
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDisclaimer).hide()
    }

    try {
      const { status, data: pricingRule } = await window.gadgetApi.fetchDiscountCode({
        code: code,
        shopID: `${shopID}`,
      })

      if (status === 'fail') {
        resetApplyDiscountBtn()
        throw 'Discount code not found!'
      }

      const subtotal = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-cart-total-price]').data('cart-total-price')
      const startDate = Date.parse(pricingRule.startsAt)
      const expirationDate = Date.parse(pricingRule.endsAt)
      const entitledCollections = pricingRule.entitledCollectionIds
      const collectionArray = []
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-cart-line-item]').each(function (i) {
        collectionArray.push(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('collections'))
      })

      let validItemInCart = entitledCollections.length === 0
      entitledCollections.forEach((collection) => {
        if (collectionArray.flat().includes(collection)) {
          validItemInCart = true
        }
      })

      const minPrice =
        pricingRule.prerequisiteSubtotalRange &&
        Number(pricingRule.prerequisiteSubtotalRange.greaterThanOrEqualTo) * 100
      const minQty =
        pricingRule.prerequisiteQuantityRange && Number(pricingRule.prerequisiteQuantityRange.greaterThanOrEqualTo)
      const cartCount = Number(jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-cart-count').data('cart-count'))

      if (Date.now() < startDate) {
        resetApplyDiscountBtn()
        throw 'Discount code is invalid!'
      } else if (Date.now() > expirationDate) {
        resetApplyDiscountBtn()
        throw 'Discount code is expired!'
      } else if (validItemInCart === false) {
        resetApplyDiscountBtn()
        throw 'Discount not applicable.'
      } else if (subtotal < minPrice) {
        resetApplyDiscountBtn()
        throw 'Discount not applicable.'
      } else if (cartCount < minQty) {
        resetApplyDiscountBtn()
        throw 'Minimum quantity not present.'
      } else if (status === 'success') {
        const checkoutUrl = `${window.location.origin}/checkout?view=api&discount=${pricingRule.title}`
        await fetch(checkoutUrl)
        localStorage.setItem('pricingRule', JSON.stringify(pricingRule))

        $button.text('Discount Added!').attr('disabled', true)
        $container.slideUp(300).removeClass('active')
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountPlusVerticalLine).show()
        ;(0,_utilities_toastNotification_js__WEBPACK_IMPORTED_MODULE_1__["default"])('Discount code applied!', '', 'success')
        buildCart()
      }
    } catch (e) {
      console.log('error: ', e)
      ;(0,_utilities_toastNotification_js__WEBPACK_IMPORTED_MODULE_1__["default"])('An error has occurred, please try again later.', '', 'error')
    }
  }

  function removeDiscountCode() {
    const discountApplyUrl = 'https://littlesleepies.com/checkout?view=api&discount=BFCMNULL'
    ;(0,_utilities_toastNotification_js__WEBPACK_IMPORTED_MODULE_1__["default"])('Removing discount code...')

    fetch(discountApplyUrl)
      .then((res) => {
        const $submitButton = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountSubmit)
        const $discountButtonText = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountButtonText)
        const $discountTagContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountTag)
        $submitButton
          .text('Apply Discount')
          .attr('disabled', false)
          .removeClass('btn-disabled')
          .addClass('btn-night transition-colors hover:bg-blush hover:color-night')
        $discountButtonText.text('Add Discount Code')
        $discountTagContainer.fadeOut()
        ;(0,_utilities_toastNotification_js__WEBPACK_IMPORTED_MODULE_1__["default"])('Discount Code Removed!', '', 'success')
        localStorage.removeItem('pricingRule')
        buildCart()
      })
      .catch((error) => {
        console.log(error)
      })
  }

  function updateDiscountTag() {
    const discount = JSON.parse(localStorage.getItem('pricingRule'))
    const $discountTagContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountTag)
    const $discountTagText = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountTagText)
    const $discountButtonText = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartDiscountButtonText)

    if (!!discount) {
      $discountButtonText.text(`Discount applied: `)
      $discountTagText.text(discount.title)
      $discountTagContainer.fadeIn()
    } else {
      $discountTagContainer.fadeOut()
    }
  }

  function processCheckout(e) {
    location.href = '/checkout'
  }

  function toggleGiftBagInCart(e) {
    e.preventDefault()
    e.stopImmediatePropagation()
    const variantId = 39435363614838

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartGiftBagCheckbox).is(':checked')) {
      const data = `form_type=product&utf8=%E2%9C%93&id=${variantId}&quantity=1`
      processCartRequest(data, urls.cartAdd)
    } else {
      const key = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`.js-cart-item[data-id='${variantId}']`).data('key')
      const data = {
        updates: {},
      }
      data.updates[key] = 0

      processCartRequest(data, urls.cartUpdate)
    }

    toggleCartNoteBadge()
  }

  function processCartRequest(data, endpoint, callback) {
    var params = {
      url: endpoint,
      data: data,
      method: 'POST',
      dataType: 'json',
      success: function (cart) {
        setCartState()
        if (callback) {
          callback(cart)
        } else {
          buildCart()
        }
      },
      error: function (err) {
        console.warn(err)
      },
    }

    jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(params)
  }

  function toggleGiftOptions(e) {
    e.stopImmediatePropagation()
    const $expandButton = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.giftOptionsExpandButton)
    const $noteContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteContainer)
    const $cartNoteChevron = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteChevron)

    if ($noteContainer.hasClass('js-cart-note-container-open')) {
      $expandButton.attr('aria-expanded', 'false')
      $noteContainer.slideUp(300)
      $noteContainer.removeClass('js-cart-note-container-open')
      $cartNoteChevron.removeClass('rotate-180')
    } else {
      $expandButton.attr('aria-expanded', 'true')
      $noteContainer.slideDown(300)
      $noteContainer.addClass('js-cart-note-container-open')
      $cartNoteChevron.addClass('rotate-180')
    }
  }

  function toggleCartNote(e) {
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)

    if ($this.is(':checked')) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteTextareaWrapper).slideDown(300)
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteTextareaWrapper).slideUp(300)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteTextarea).val('').trigger('change')
    }
    toggleCartNoteBadge()
  }

  function toggleCartNoteBadge(e) {
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteToggle).is(':checked') || jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartGiftBagCheckbox).is(':checked')) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteBadge).removeClass('hidden')
    } else {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartNoteBadge).addClass('hidden')
    }
  }

  function updateCartNote(e) {
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let value = $this.val()

    let data = {
      note: value,
    }

    processCartRequest(data, urls.cartUpdate, function () {})
  }

  function updateItemQuantity(e) {
    e.preventDefault()
    e.stopImmediatePropagation()
    const $numberInput = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).siblings(settings.itemQuantity)
    let quantity = parseInt(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('quantity'))
    const max = parseInt($numberInput.attr('max'))
    const difference = max - quantity
    const id = $numberInput.data('id')
    const $pdpQtyInput = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-qty__num-select')
    const pdpId = $pdpQtyInput.data('id')

    if (quantity <= max) {
      $numberInput.val(quantity).trigger('change')
    }

    if (pdpId === id) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-qty__num-select')
        .find('option')
        .map((index, opt) => {
          optVal = Number(jquery__WEBPACK_IMPORTED_MODULE_0___default()(opt).html())

          optVal > difference ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(opt).attr('disabled', true) : jquery__WEBPACK_IMPORTED_MODULE_0___default()(opt).attr('disabled', false)
        })
    }
  }

  function adjustItemQuantity(e) {
    e.preventDefault()
    e.stopImmediatePropagation()
    const $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const key = $this.data('key')

    const data = {
      updates: {
        [key]: $this.val(),
      },
    }

    processCartRequest(data, urls.cartUpdate)
  }

  function handleProductSubmit(e) {
    e.preventDefault()
    e.stopImmediatePropagation()
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let data = $this.serialize()
    let isPdpUpsellProduct = $this.data('pdp-upsell-product')
    $elementToFocusOnClose = $this.find('button[type="submit"]')

    if ($this.hasClass('pdp-product-form')) {
      // Find all checked PDP upsell checkboxes
      const $checkedUpsellCheckboxes = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpUpsellAddCheckbox + ':checked')

      if ($checkedUpsellCheckboxes.length > 0) {
        // Parse the main form data
        let mainFormData = new URLSearchParams(data)
        let allProducts = []

        // Add main product
        allProducts.push({
          id: mainFormData.get('id'),
          quantity: mainFormData.get('quantity') || 1,
          properties: {
            _upsellItem: true,
            _upsellType: 'product-upsell',
            _upsellMain: true,
          },
        })

        // Add each checked upsell product
        $checkedUpsellCheckboxes.each(function () {
          const $checkbox = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
          const $upsellForm = $checkbox.closest(settings.pdpUpsellForm)
          const upsellCategory = $checkbox.data('pdp-upsell-category')

          if ($upsellForm.length) {
            const upsellData = new URLSearchParams($upsellForm.serialize())
            allProducts.push({
              id: upsellData.get('id'),
              quantity: upsellData.get('quantity') || 1,
              properties: {
                _upsellItem: true,
                _upsellType: 'product-upsell',
                _upsellSecondary: true,
                _upsellCategory: upsellCategory,
              },
            })
          }
        })

        const upsellData = {
          items: allProducts,
        }

        jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: upsellData,
          success: (res) => {
            buildCart()
            openCart()
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-pdp-quantity-input').val(1)
            Product.setSelectedQuantity(1)
          },
          error: (error) => console.log(error),
        })
      } else {
        // No upsell products selected, proceed normally
        processCartRequest(data, urls.cartAdd, () => {
          buildCart()
          openCart()
          jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-pdp-quantity-input').val(1)
          Product.setSelectedQuantity(1)
        })

        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpUpsellATC).removeClass('hidden').addClass('block')
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpUpsellAddCheckbox).parents('fieldset').removeClass('block').addClass('hidden')
      }
    } else {
      // Not a PDP product form or upsell form with a pdp upsell product, proceed normally
      processCartRequest(data, urls.cartAdd, () => {
        buildCart()
        openCart()
        jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-pdp-quantity-input').val(1)
        Product.setSelectedQuantity(1)
      })
    }

    // Check if the form has a parent with class quick-shop-drawer and close it
    const $quickShopDrawer = $this.closest('.quick-shop-drawer')
    if ($quickShopDrawer.length > 0) {
      $quickShopDrawer.find('.js-drawer-close').trigger('click')
    }

    // Horizon Media Add to Cart
    window.nf0('trackStructEvent', 'custom_conversion', 'add_to_cart')
  }

  function handleItemRemove(e) {
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let key = $this.data('key')
    let id = $this.data('id')
    const pdpId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-qty__num-select').data('id')

    let data = {
      updates: {
        [key]: 0,
      },
    }

    processCartRequest(data, urls.cartUpdate, function () {
      buildCart(['header', 'items', 'upsell', 'footer'])
    })

    if (id === 6605525745782) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartGiftBagCheckbox).prop('checked', false)
    }

    if (pdpId === id) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-qty__num-select').find('option').attr('disabled', false)
    }
  }

  function getCart(callback) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(urls.cartGet).then(callback)
  }

  function getCookieValue(name) {
    const regex = new RegExp(`(^| )${name}=([^;]+)`)
    const match = document.cookie.match(regex)
    if (match) {
      return match[2]
    }
  }

  function updateCartIndicator(cart) {
    //update cart count text in header
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-cart-count-text]').text(cart.item_count)

    //update cart indicator visibility
    const $cartIndicator = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-cart-indicator]')
    if (cart.item_count > 0) {
      $cartIndicator.show()
    } else {
      $cartIndicator.hide()
    }
  }

  function buildCart(sectionsToRender = ['header', 'items', 'notes', 'upsell', 'footer']) {
    const showDiscount = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).data('show-discount')

    getCart(function (cart) {
      const testId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).data('test-id')
      // const testNumber = getCookieValue(`debug_vis_opt_exp_${testId}_split`) || 1
      // const cartSectionUrl = `/?sections=ajax-cart-${testNumber}`
      const cartSectionUrl = `/?sections=ajax-cart`

      jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(cartSectionUrl)
        .then(function (response) {
          // if (!response[`ajax-cart-${testNumber}`]) {
          if (!response[`ajax-cart`]) {
            return
          }

          // let $response = $(response[`ajax-cart-${testNumber}`])
          let $response = jquery__WEBPACK_IMPORTED_MODULE_0___default()(response[`ajax-cart`])
          let hiddenItemCount = 0

          let $newInnerHTML = $response.find(settings.slideCartInner)

          if (showDiscount) {
            $newInnerHTML = renderDiscountedPrices($newInnerHTML, cart)
          }

          if (cart.item_count > 0 && jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-slide-cart--items').length) {
            sectionsToRender.forEach(function (section) {
              let $sectionEl = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).find(`.js-slide-cart--${section}`)

              let $newEl = $newInnerHTML.find(`.js-slide-cart--${section}`)
              $sectionEl.replaceWith($newEl)
            })
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer).find(settings.slideCartInner).replaceWith($newInnerHTML)
          }

          if (showDiscount) {
            updateDiscountTag()
          }

          //update cart indicator and count
          updateCartIndicator(cart)

          // hide/show diff announcment bars
          if (cart.item_count > 0) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-announcement-bar-type="regular"]').hide()
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-announcement-bar-type="cart"]').show()
          } else {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-announcement-bar-type="cart"]').hide()
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-announcement-bar-type="regular"]').show()
          }

          //update announcement bar cart count
          jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-announcement-cart-count]').text(cart.item_count)
          jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-announcement-cart-plural]').text(cart.item_count === 1 ? 'item' : 'items')
          jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-announcement-cart-verb]').text(cart.item_count === 1 ? 'is' : 'are')

          // Handle announcement bar wrapper divs visibility
          const $countWrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-announcement-cart-count-wrapper]')
          const $textWrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-announcement-cart-text-wrapper]')

          if (cart.item_count > 0) {
            $countWrapper.show()
            $textWrapper.hide()
          } else {
            $countWrapper.hide()
            $textWrapper.show()
          }
        })
        .catch(function () {})
    })
  }

  function openCart(e) {
    if (e) {
      e.preventDefault()

      $elementToFocusOnClose = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    }

    let $cartContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer)
    $cartContainer.show()

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartOverlay).fadeIn(400)

    setTimeout(function () {
      $cartContainer.addClass('active on')
    }, 10)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.closeCart).focus()

    disableScroll()
  }

  function closeCart(e) {
    if (e) {
      e.preventDefault()
      e.stopImmediatePropagation()
    }

    let $cartContainer = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slideCartContainer)
    $cartContainer.removeClass('active on')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.cartOverlay).fadeOut(400)

    setTimeout(function () {
      $cartContainer.hide()

      if ($elementToFocusOnClose && $elementToFocusOnClose.length) {
        $elementToFocusOnClose.focus()
      }
    }, 600)

    enableScroll()
  }

  return {
    getState,
  }
}


/***/ }),

/***/ 2773:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const useState = (defaultValue) => {
  let value = defaultValue
  const getValue = () => value
  const setValue = (newValue) => (value = newValue)
  return [getValue, setValue]
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useState);


/***/ }),

/***/ 3566:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const showToastNotification = function (message, url, status = 'warning') {
  const $toastContainer = $('[data-registry-wishlist-toast-container]')
  const bgColor = {
    success: 'bg-successGreen',
    warning: 'bg-moon',
    error: 'bg-errorPink',
  }

  const $toast = $.parseHTML(`<div
      class="animate-fadeInUp animate-duration-[800ms] text-base font-galano font-bold text-galaxt leading-none rounded ${
        bgColor[status]
      } shadow-sm py-4 px-5 mx-auto flex items-center justify-center gap-2 transition-all w-full max-w-[calc(100vw_-_32px)] lg:max-w-[600px]"
    >
      ${
        status === 'success'
          ? `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12.3333 7L7.75 11.5833L5.66666 9.5" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>      
      `
          : `
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 1C13.4183 1 17 4.58172 17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1Z" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 5.79996V9.66663" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 12.2H9.01067" stroke="#3D3C3D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `
      }
      <span>${message}${
    url && url !== '' ? ` - <a href="${url}" class="text-galaxy underline hover:no-underline">View</a></span>` : ''
  }
    </div>`)

  $toastContainer.append($toast)
  const $toastNode = $toastContainer.children().last()

  setTimeout(function () {
    $toastNode.removeClass('animate-fadeInUp').addClass('animate-fadeOutDown')
    setTimeout(function () {
      $toastNode.remove()
    }, 500)
  }, 3500)
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (showToastNotification);


/***/ }),

/***/ 4559:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ productPage)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var photoswipe_lightbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2214);
/* harmony import */ var photoswipe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8300);
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9822);
/* harmony import */ var _global_slide_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2380);






const SlideCart = (0,_global_slide_cart__WEBPACK_IMPORTED_MODULE_4__["default"])()

function productPage() {
  var defaultVariantId = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-pdp-hidden-select').val()

  const [selectedVariantId, setSelectedVariantId] = (0,_utilities__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultVariantId)
  const [selectedQuantity, setSelectedQuantity] = (0,_utilities__WEBPACK_IMPORTED_MODULE_3__.useState)(1)
  const state = {}

  const settings = {
    accordionContainers: '[data-pdp-accordion-container]',
    accordionButton: '[data-pdp-accordion-button]',
    addToCartBtn: '.js-add-to-cart',
    closeStickyATCButton: '.js-close-sticky-atc-button',
    hiddenSelect: '.js-pdp-hidden-select',
    productForm: "form[action='/cart/add']",
    quantityInputContainer: '.js-pdp-quantity-input-container',
    quantityButtons: '.js-pdp-quantity-button',
    quantityInput: '.js-pdp-quantity-input',
    selectedAgeText: '[data-selected-age-text]',
    selectedSizeText: '[data-selected-size-text]',
    sizeChartModal: '[data-size-chart-modal]',
    sizeChartOverlay: '[data-size-chart-overlay]',
    sizeChartModalClose: '[data-size-chart-modal-close]',
    sizeChartModalOpen: '[data-size-chart-modal-open]',
    sizeGroupButtons: '[data-size-group-button]',
    sizeGroupLinks: '[data-size-group-link]',
    sizeVariantButtons: '[data-size-variant-button]',
    stickyATC: '.pdp-sticky-atc-wrapper',
    stickyATCButton: '.js-sticky-atc-button',
    stickyATCOverlay: '.js-sticky-atc-overlay',
    stickyATCModal: '.js-sticky-atc-modal',
    stickyATCSizeButtons: '.js-pdp-item-size-radio',
    stickyATCModalATCButton: '.js-cart-sticky-atc-modal-button',
    stickyATCHiddenSelect: '.js-sticky-atc-modal-hidden-select',
    variantRadios: '.js-pdp-variant-radio',
    gwButton: '.gwbutton',
    gwButtonContainer: '[data-gw-button-container]',
    colorRadios: '.js-pdp-color-radio',
    sizeRadios: '.js-pdp-size-radio',
    weightRadios: '.js-pdp-weight-radio',
    hiddenColorSelect: '.js-pdp-hidden-color-select',
    pdpColorSwatch: '.js-pdp-color-swatch',
    images: '.photoswipe__image',
    productPrice: '[data-product-price]',
    zoomButton: '[data-pdp-image-zoom-button]',
    gifToggle: '[data-gif-toggle]',
    gifContainer: '[data-gif-container]',
    videoToggleBtn: '[data-video-toggle-btn]',
    videoContainer: '[data-pdp-video-container]',
    videoElement: '[data-pdp-video]',
    mobileTooltip: '[data-lunaluxe-tooltip-mobile]',
    mobileTooltipTrigger: '[data-lunaluxe-tooltip-trigger-mobile]',
    desktopTooltip: '[data-lunaluxe-tooltip-desktop]',
    desktopTooltipTrigger: '[data-lunaluxe-tooltip-trigger-desktop]',
    desktopTooltipContainer: '[data-tooltip-desktop-container]',
    playSleepToggle: '[data-play-sleep-toggle]',
    stlRecToggleSection: '[data-stl-rec-toggle-section]',
    stlRecToggle: '[data-stl-rec-toggle]',
    stlWrapper: '[data-shop-the-look-wrapper]',
    recWrapper: '[data-rec-products-wrapper]',
    drawerContent: '[data-drawer-content]',
    drawerTrigger: '[data-drawer-trigger]',
    drawerSubheader: '[data-drawer-subheader]',
    drawerHeaderSleep: '[data-drawer-header-sleep]',
    drawerProductsSleep: '[data-drawer-products-sleep]',
    drawerFooterSleep: '[data-drawer-footer-sleep]',
    drawerToggleSleep: '[data-toggle-drawer-content="sleep"]',
    drawerHeaderPlay: '[data-drawer-header-play]',
    drawerSubheaderPlay: '[data-drawer-subheader-play]',
    drawerProductsPlay: '[data-drawer-products-play]',
    drawerFooterPlay: '[data-drawer-footer-play]',
    drawerTogglePlay: '[data-toggle-drawer-content="play"]',
    pdpUpsellAddCheckbox: '[data-pdp-upsell-add-input]',
    pdpUpsellATC: '[data-pdp-upsell-atc]',
    pdpUpsellSizeSelect: '[data-upsell-size-select]',
    pdpUpsellSizeOption: '[data-upsell-size-option]',
    pdpUpsellDiscountBadge: '[data-upsell-discount-badge]',
    pdpUpsellDiscountPrice: '[data-product-upsell-discount-price]',
  }

  ;(function init() {
    initializeEventListeners()
  })()

  function initializeEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.variantRadios).on('click', changeSelectedVariant)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.variantRadios).on('keydown', handleVariantKeydown)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.pdp-variant-select-label').on('click', function (e) {
      // Only trigger if clicking on the label itself, not the radio input
      if (e.target === this) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).find('input[type="radio"]').trigger('click')
      }
    })
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.pdp-variant-select-label').on('keydown', handleVariantKeydown)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.quantityButtons).on('click', changeItemQuantity)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('submit', settings.productForm, handleProductSubmit)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.accordionButton).on('click', toggleAccordion)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', settings.sizeChartModalOpen, revealSizeChartModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', settings.sizeChartModalClose, hideSizeChartModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', settings.sizeChartOverlay, hideSizeChartModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATCButton).on('click', revealStickyATCModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATCOverlay).on('click', closeStickyATCModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.closeStickyATCButton).on('click', closeStickyATCModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATCSizeButtons).on('click', handleModalSizeChange)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATCModalATCButton).on('click', closeStickyATCModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeGroupButtons).on('click', changeActiveSize)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.gifToggle).on('click', toggleGif)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.videoToggleBtn).on('click', toggleVideo)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.mobileTooltipTrigger).on('click', revealMobileTooltip)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.desktopTooltipTrigger).on('mouseover', revealDesktopTooltip)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.desktopTooltipTrigger).on('click', revealDesktopTooltip)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.desktopTooltipContainer).on('mouseleave', hideDesktopTooltip)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stlRecToggle).on('change', toggleStlRec)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerTrigger).on('click', showDrawerContent)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerToggleSleep).on('click', toggleDrawerContent)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerTogglePlay).on('click', toggleDrawerContent)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpUpsellAddCheckbox).on('change', handleProductDiscountPriceChange)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', hideMobileTooltip)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('scroll', toggleStickyATC)

    if ((0,_utilities__WEBPACK_IMPORTED_MODULE_3__.elementsExist)([jquery__WEBPACK_IMPORTED_MODULE_0___default()('.pdp-hero')])) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('load', initLightbox)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('load', filterSizeButtons)
    }
    if ((0,_utilities__WEBPACK_IMPORTED_MODULE_3__.elementsExist)([jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.colorRadios), jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeRadios)])) {
      const activeVariant = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).find('option[data-available="true"]').first()
      state.size = activeVariant.data('option-1')
      state.color = activeVariant.data('option-2')
      state.selectedVariant = activeVariant.val()
      setSelectedVariantId(activeVariant.val())
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).val(activeVariant.val())
      selectFirstAvailableVariantOnPageLoad()

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.colorRadios).on('change', handleColorChange)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeRadios).on('change', handleSizeChange)
    } else if ((0,_utilities__WEBPACK_IMPORTED_MODULE_3__.elementsExist)([jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeRadios), jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.weightRadios)])) {
      const activeVariant = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).find('option[data-available="true"]').first()
      state.size = activeVariant.data('option-2')
      state.weight = activeVariant.data('option-1')
      state.selectedVariant = activeVariant.val()
      setSelectedVariantId(activeVariant.val())
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).val(activeVariant.val())
      selectFirstAvailableBagVariantOnPageLoad()

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeRadios).on('change', handleSleepyBagSizeChange)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.weightRadios).on('change', handleWeightChange)
    }
  }

  function toggleStlRec(e) {
    e.stopImmediatePropagation()
    const $toggleSection = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stlRecToggleSection)
    const $stlWrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stlWrapper)
    const $recWrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.recWrapper)

    // Prevent multiple rapid clicks
    if ($toggleSection.is(':animated')) {
      return
    }

    // Get current state
    const isCurrentlyOn = $toggleSection.hasClass('on')
    const currentHeight = $toggleSection.outerHeight()

    // Toggle the class first
    $toggleSection.toggleClass('on')

    if ($toggleSection.hasClass('on')) {
      // Switching to recommendations
      // Pre-measure the recommendations height before any transitions
      const originalDisplay = $recWrapper.css('display')
      $recWrapper.css({
        position: 'absolute',
        visibility: 'hidden',
        display: 'block',
        opacity: '1',
      })
      const recHeight = $recWrapper.outerHeight()
      $recWrapper.css({
        position: '',
        visibility: '',
        display: originalDisplay,
        opacity: '',
      })

      // Set current height to prevent jumping
      $toggleSection.css('height', currentHeight + 'px')

      // Fade out shop the look
      $stlWrapper.fadeOut(300, function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('aria-hidden', true)
        // Fade in recommendations and animate height simultaneously
        $recWrapper.fadeIn(300)
        $toggleSection.animate({ height: recHeight }, 300, function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css('height', 'fit-content')
        })
        $recWrapper.attr('aria-hidden', false)
      })
    } else {
      // Switching to shop the look
      // Pre-measure the shop the look height before any transitions
      const originalDisplay = $stlWrapper.css('display')
      $stlWrapper.css({
        position: 'absolute',
        visibility: 'hidden',
        display: 'block',
        opacity: '1',
      })
      const stlHeight = $stlWrapper.outerHeight()
      $stlWrapper.css({
        position: '',
        visibility: '',
        display: originalDisplay,
        opacity: '',
      })

      // Set current height to prevent jumping
      $toggleSection.css('height', currentHeight + 'px')

      // Fade out recommendations
      $recWrapper.fadeOut(300, function () {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('aria-hidden', true)
        // Fade in shop the look and animate height simultaneously
        $stlWrapper.fadeIn(300)
        $toggleSection.animate({ height: stlHeight }, 300, function () {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).css('height', 'fit-content')
        })
        $stlWrapper.attr('aria-hidden', false)
      })
    }
  }

  function revealDesktopTooltip(e) {
    e.stopPropagation()
    const $tooltip = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.desktopTooltip)
    const eventType = e.type

    if (!$tooltip.hasClass('!block')) {
      $tooltip.addClass('!block')
    } else if ($tooltip.hasClass('!block') && eventType === 'click') {
      $tooltip.removeClass('!block')
    }
  }

  function hideDesktopTooltip(e) {
    e.stopPropagation()
    const $tooltip = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.desktopTooltip)
    if ($tooltip.hasClass('!block')) {
      $tooltip.removeClass('!block')
    }
  }

  function revealMobileTooltip(e) {
    e.stopPropagation()
    const $tooltip = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.mobileTooltip)
    if (!$tooltip.hasClass('!block')) {
      $tooltip.addClass('!block')
    } else {
      $tooltip.removeClass('!block')
    }
  }

  function hideMobileTooltip(e) {
    e.stopPropagation()
    const $tooltip = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.mobileTooltip)
    if ($tooltip.hasClass('!block')) {
      $tooltip.removeClass('!block')
    }
  }

  // Start Play Sleep Toggle Drawer Logic //
  const sleepContent = [settings.drawerHeaderSleep, settings.drawerProductsSleep, settings.drawerFooterSleep]
  const playContent = [settings.drawerHeaderPlay, settings.drawerProductsPlay, settings.drawerFooterPlay]

  function showDrawerContent() {
    let drawerVersion = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('drawer-trigger')

    if (drawerVersion == 'sleep') {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerContent).addClass('bg-periwinkle').removeClass('bg-mint')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerSubheader).text('Try this print in these Sleep styles!')
      // sleep
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerToggleSleep).addClass('on').attr('disabled', true)
      jquery__WEBPACK_IMPORTED_MODULE_0___default().each(sleepContent, function (index, content) {
        if (index == sleepContent.length - 1) {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).css('display', 'flex').attr('aria-hidden', false)
        } else {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).css('display', 'block').attr('aria-hidden', false)
        }
      })
      //play
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerTogglePlay).removeClass('on').attr('disabled', false)
      jquery__WEBPACK_IMPORTED_MODULE_0___default().each(playContent, function (index, content) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).css('display', 'none').attr('aria-hidden', true)
      })
    } else if (drawerVersion == 'play') {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerContent).addClass('bg-mint').removeClass('bg-periwinkle')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerSubheader).text('Try this print in these Play styles!')

      // play
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerTogglePlay).addClass('on').attr('disabled', true)
      jquery__WEBPACK_IMPORTED_MODULE_0___default().each(playContent, function (index, content) {
        if (index == playContent.length - 1) {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).css('display', 'flex').attr('aria-hidden', false)
        } else {
          jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).css('display', 'block').attr('aria-hidden', false)
        }
      })
      // sleep
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerToggleSleep).removeClass('on').attr('disabled', false)
      jquery__WEBPACK_IMPORTED_MODULE_0___default().each(sleepContent, function (index, content) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).css('display', 'none').attr('aria-hidden', true)
      })
    }
  }

  function toggleDrawerContent() {
    let drawerVersion = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('toggle-drawer-content')

    jquery__WEBPACK_IMPORTED_MODULE_0___default().each(sleepContent, function (index, content) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).fadeToggle()
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default().each(playContent, function (index, content) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).fadeToggle()
    })

    if (drawerVersion == 'sleep') {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerContent).addClass('bg-periwinkle').removeClass('bg-mint')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerSubheader).text('Try this print in these Sleep styles!')

      // sleep
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerToggleSleep).addClass('on').attr('disabled', true)
      jquery__WEBPACK_IMPORTED_MODULE_0___default().each(sleepContent, function (index, content) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).attr('aria-hidden', false)
      })
      //play
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerTogglePlay).removeClass('on').attr('disabled', false)
      jquery__WEBPACK_IMPORTED_MODULE_0___default().each(playContent, function (index, content) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).attr('aria-hidden', true)
      })
    } else if (drawerVersion == 'play') {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerContent).addClass('bg-mint').removeClass('bg-periwinkle')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerSubheader).text('Try this print in these Play styles!')

      // play
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerTogglePlay).addClass('on').attr('disabled', true)
      jquery__WEBPACK_IMPORTED_MODULE_0___default().each(playContent, function (index, content) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).attr('aria-hidden', false)
      })
      // sleep
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.drawerToggleSleep).removeClass('on').attr('disabled', false)
      jquery__WEBPACK_IMPORTED_MODULE_0___default().each(sleepContent, function (index, content) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(content).attr('aria-hidden', true)
      })
    }
  }

  // End Play Sleep Toggle Drawer Logic //

  function changeActiveSize(e) {
    e.preventDefault()
    let url = location.pathname
    const activeSizes = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('size-group-button')
    url = url + '?active-sizes=' + activeSizes
    handleHistoryReplacement(url)
    filterSizeButtons()
  }

  function filterSizeButtons() {
    const urlParams = new URLSearchParams(window.location.search)
    const sizesString = urlParams.get('active-sizes')
    if (!sizesString) {
      return
    }

    const sizesArray = sizesString.split(',')

    const $activeSizeButtons = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeVariantButtons).filter(function () {
      return sizesArray.includes(`${jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('size-variant-button')}`)
    })
    const $notActiveSizeButtons = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeVariantButtons).not($activeSizeButtons)

    const $activeGroupButton = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeGroupButtons).filter(function () {
      return jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('size-group-button') === sizesString
    })
    const $notActiveGroupButtons = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeGroupButtons).not($activeGroupButton)
    const $ageTextNode = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.selectedAgeText)
    const activeGroupName = $activeGroupButton.data('group-title')
    $activeSizeButtons.removeClass('hidden')
    $notActiveSizeButtons.addClass('hidden')

    $activeGroupButton.addClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
    $notActiveGroupButtons.removeClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')

    $ageTextNode.html(`Age: <span>${activeGroupName}</span>`)
  }

  function handleHistoryReplacement(href) {
    if (href) history.replaceState('', '', href)
  }

  function toggleVideo(e) {
    e.stopImmediatePropagation()
    const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const $pauseIcon = $button.find('[data-video-pause-icon]')
    const $playIcon = $button.find('[data-video-play-icon]')
    const $srText = $button.find('[data-video-sr-text]')
    const $container = $button.parents(settings.videoContainer)
    const $video = $container.find(settings.videoElement)

    if ($video.data('playing')) {
      $video.get(0).pause()
      $video.data('playing', false)
      $playIcon.removeClass('hidden')
      $pauseIcon.addClass('hidden')
      $srText.text('Click to play.')
    } else {
      $video.get(0).play()
      $video.data('playing', true)
      $playIcon.addClass('hidden')
      $pauseIcon.removeClass('hidden')
      $srText.text('Click to pause')
    }
  }

  function initLightbox() {
    const mobileLightbox = new photoswipe_lightbox__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A({
      gallery: '[data-js-light-box-target-mobile]',
      children: 'a',
      pswpModule: () => photoswipe__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A,
      trapFocus: false,
      returnFocus: true,
    })

    const desktopLightbox = new photoswipe_lightbox__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A({
      gallery: '[data-js-light-box-target-desktop]',
      children: 'a',
      pswpModule: () => photoswipe__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A,
      trapFocus: false,
      returnFocus: true,
    })

    // Add accessibility event listeners to fix ARIA issues
    mobileLightbox.on('beforeOpen', () => {
      // Remove problematic aria-roledescription attribute and add modal attributes
      setTimeout(() => {
        const scrollWrap = document.querySelector('.pswp__scroll-wrap')
        if (scrollWrap && scrollWrap.hasAttribute('aria-roledescription')) {
          scrollWrap.removeAttribute('aria-roledescription')
        }
        
        // Add proper carousel accessibility attributes to scroll wrap
        if (scrollWrap) {
          scrollWrap.setAttribute('aria-label', 'Product image carousel')
        }

        // Add proper modal attributes to PhotoSwipe root element
        const pswpElement = document.querySelector('.pswp')
        if (pswpElement) {
          pswpElement.setAttribute('role', 'dialog')
          pswpElement.setAttribute('aria-modal', 'true')
          pswpElement.setAttribute('aria-label', 'Product image lightbox')
        }
      }, 0)
    })

    desktopLightbox.on('beforeOpen', () => {
      // Remove problematic aria-roledescription attribute and add modal attributes
      setTimeout(() => {
        const scrollWrap = document.querySelector('.pswp__scroll-wrap')
        if (scrollWrap && scrollWrap.hasAttribute('aria-roledescription')) {
          scrollWrap.removeAttribute('aria-roledescription')
        }
        
        // Add proper carousel accessibility attributes to scroll wrap
        if (scrollWrap) {
          scrollWrap.setAttribute('aria-label', 'Product image carousel')
        }

        // Add proper modal attributes to PhotoSwipe root element
        const pswpElement = document.querySelector('.pswp')
        if (pswpElement) {
          pswpElement.setAttribute('role', 'dialog')
          pswpElement.setAttribute('aria-modal', 'true')
          pswpElement.setAttribute('aria-label', 'Product image lightbox')
        }
      }, 0)
    })

    // Add document-level focus trapping when PhotoSwipe is open
    mobileLightbox.on('uiRegister', () => {
      document.addEventListener('keydown', handleDocumentKeydown)
    })

    desktopLightbox.on('uiRegister', () => {
      document.addEventListener('keydown', handleDocumentKeydown)
    })

    // Remove focus trap when PhotoSwipe closes
    mobileLightbox.on('close', () => {
      document.removeEventListener('keydown', handleDocumentKeydown)
    })

    desktopLightbox.on('close', () => {
      document.removeEventListener('keydown', handleDocumentKeydown)
    })

    // Add proper accessibility attributes to slides
    mobileLightbox.on('slideLoad', (e) => {
      const slide = e.slide
      const slideElement = slide.holderElement
      if (slideElement) {
        slideElement.setAttribute('role', 'group')
        const currentIndex = slide.index + 1
        const totalSlides = mobileLightbox.pswp?.getNumItems() || 1
        slideElement.setAttribute('aria-label', `slide ${currentIndex} of ${totalSlides}`)
      }
    })

    desktopLightbox.on('slideLoad', (e) => {
      const slide = e.slide
      const slideElement = slide.holderElement
      if (slideElement) {
        slideElement.setAttribute('role', 'group')
        const currentIndex = slide.index + 1
        const totalSlides = desktopLightbox.pswp?.getNumItems() || 1
        slideElement.setAttribute('aria-label', `slide ${currentIndex} of ${totalSlides}`)
      }
    })

    // Focus on close button when PhotoSwipe opens
    mobileLightbox.on('uiRegister', () => {
      setTimeout(() => {
        const closeButton = document.querySelector('.pswp__button--close')
        if (closeButton) {
          closeButton.focus()
        }
      }, 100)
    })

    desktopLightbox.on('uiRegister', () => {
      setTimeout(() => {
        const closeButton = document.querySelector('.pswp__button--close')
        if (closeButton) {
          closeButton.focus()
        }
      }, 100)
    })

    mobileLightbox.init()
    desktopLightbox.init()
  }

  function toggleGif() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.gifContainer).toggleClass('on')
  }

  function handleDocumentKeydown(event) {
    const { key, target } = event

    // Only handle Tab key for focus trapping
    if (key !== 'Tab') return

    // Check if PhotoSwipe is open
    const pswpElement = document.querySelector('.pswp.pswp--open')
    if (!pswpElement) return

    // Get all focusable elements within PhotoSwipe
    const focusableElements = pswpElement.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]'
    )

    if (focusableElements.length === 0) return

    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    // Check if the focused element is outside PhotoSwipe
    const isOutsidePhotoSwipe = !pswpElement.contains(target)

    if (isOutsidePhotoSwipe) {
      event.preventDefault()
      event.stopPropagation()
      firstElement.focus()
      return
    }

    // Check if we're tabbing out of the modal
    const isTabbingOutForward = target === lastElement && !event.shiftKey
    const isTabbingOutBackward = target === firstElement && event.shiftKey

    if (isTabbingOutForward || isTabbingOutBackward) {
      event.preventDefault()
      event.stopPropagation()

      if (isTabbingOutBackward) {
        lastElement.focus()
      } else if (isTabbingOutForward) {
        firstElement.focus()
      }
    }
  }

  function selectFirstAvailableVariantOnPageLoad() {
    const $activeColorSwatch = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`${settings.colorRadios}[value="${state.color}"]`).parent(settings.pdpColorSwatch)
    const $notActiveColorSwatches = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpColorSwatch).not($activeColorSwatch)
    $activeColorSwatch.addClass('pdp-color-swatch-active')
    $notActiveColorSwatches.removeClass('pdp-color-swatch-active')

    const $activeSizeLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`${settings.sizeRadios}[value="${state.size}"]`).parent()
    const $notActiveSizeLabels = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeRadios).not($activeSizeLabel)
    $activeSizeLabel.addClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
    $notActiveSizeLabels.removeClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')

    updateSizeSelectorAvailability()
  }

  function selectFirstAvailableBagVariantOnPageLoad() {
    const $activeSizeLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`${settings.sizeRadios}[value="${state.size}"]`).parent()
    const $notActiveSizeLabels = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeRadios).not($activeSizeLabel)
    $activeSizeLabel.addClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
    $notActiveSizeLabels.removeClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')

    const $activeWeightLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`${settings.weightRadios}[value="${state.weight}"]`).parent()
    const $notActiveWeightLabels = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.weightRadios).not($activeWeightLabel)
    $activeWeightLabel.addClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
    $notActiveWeightLabels.removeClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')

    updateSizeSelectorAvailabilitySleepyBag()
    updateWeightSelectorAvailability()
    enableATCBtn()
  }

  function handleColorChange(e) {
    const color = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val()
    state.color = color
    const $registryButton = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-hook="add-to-registry"]')
    const $registryText = $registryButton.find('[data-registry-atc-text]')

    $registryButton.removeClass('cursor-not-allowed').attr('disabled', false)
    $registryText.text('Add to Registry')
    toggleActiveColorSwatch(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this))
    scrollToSelectedColorPhoto()
    updateSizeSelectorAvailability()
    updateSelectedSize()
    updateSelectedVariant()
  }

  function handleWeightChange(e) {
    const weight = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val()
    state.weight = weight
    const $registryButton = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-hook="add-to-registry"]')
    const $registryText = $registryButton.find('[data-registry-atc-text]')

    const $parentLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent('.pdp-variant-select-label')
    $parentLabel.addClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-weight-label]')
      .not($parentLabel)
      .removeClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
    updateSleepyBagSelectedSize()
    updateSleepyBagVariant()
    updateProductMaxQty()
    $registryButton.removeClass('cursor-not-allowed').attr('disabled', false)
    $registryText.text('Add to Registry')
  }

  function toggleActiveColorSwatch($this) {
    const $selectedColor = $this.parent(settings.pdpColorSwatch)
    $selectedColor.addClass('pdp-color-swatch-active')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpColorSwatch).not($selectedColor).removeClass('pdp-color-swatch-active')
  }

  function scrollToSelectedColorPhoto() {
    const $image = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.images).filter(function () {
      const alt = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('alt').toLowerCase()
      const color = state.color.toLowerCase()
      return alt.includes(color) && !jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parents('.slick-slide').hasClass('slick-cloned')
    })
    const $parent = $image.parents('.slick-slide')
    const index = $parent.data('slick-index')

    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-hero-images').slick('slickGoTo', index)
  }

  function updateSelectedSize() {
    let $newSelectedVariant = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).find(`option[value="${state.selectedVariant}"]`)
    const variantAvailable = $newSelectedVariant.data('available')
    let price = $newSelectedVariant.data('variant-price')

    // If the currently selected weight is available in the new size, this is fine and exit this function
    if (variantAvailable) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).text('$' + price)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).data('gip-original-value', price)
      enableATCBtn()
      return
    }

    // If not, proceed with setting new selected size
    $newSelectedVariant = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect)
      .find(`option[data-option-2="${state.color}"][data-available="true"]`)
      .first()

    price = $newSelectedVariant.data('variant-price')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).text(`$${price}`)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).data('gip-original-value', price)

    if ($newSelectedVariant.length > 0) {
      // If the new color has any available size variants, proceed with setting the first one that was found
      state.size = $newSelectedVariant.data('option-1')
      state.selectedVariant = $newSelectedVariant.val()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).val(state.selectedVariant)
      const $selectedSizeLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`.js-pdp-size-radio[value="${state.size}"]`).parent('.pdp-variant-select-label')
      const $notSelectedSizeLabels = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.pdp-variant-select-label').not($selectedSizeLabel)
      $selectedSizeLabel.addClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
      $notSelectedSizeLabels.removeClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
      enableATCBtn()
    } else {
      // If not, no sizes are available for this color, remove all selections
      state.size = ''
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).val('')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.pdp-variant-select-label').removeClass(
        'pdp-variant-select-label-active holiday-pdp-variant-select-label-active'
      )
      disableATCBtn()
    }
  }

  function updateSleepyBagSelectedSize() {
    let $newSelectedVariant = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).find(`option[value="${state.selectedVariant}"]`)
    const variantAvailable = $newSelectedVariant.data('available')
    let price = $newSelectedVariant.data('variant-price')

    // If the currently selected size is available in the new color, this is fine and exit this function
    if (variantAvailable) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).text('$' + price)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).data('gip-original-value', price)
      enableATCBtn()

      return
    }

    // If not, proceed with setting new selected size
    $newSelectedVariant = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect)
      .find(`option[data-option-1="${state.weight}"][data-available="true"]`)
      .first()

    price = $newSelectedVariant.data('variant-price')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).text(`$${price}`)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).data('gip-original-value', price)

    if ($newSelectedVariant.length > 0) {
      // If the new color has any available size variants, proceed with setting the first one that was found
      state.size = $newSelectedVariant.data('option-2')
      state.selectedVariant = $newSelectedVariant.val()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).val(state.selectedVariant)
      const $selectedSizeLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`.js-pdp-size-radio[value="${state.size}"]`).parent('.pdp-variant-select-label')
      const $notSelectedSizeLabels = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-size-label]').not($selectedSizeLabel)
      $selectedSizeLabel.addClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
      $notSelectedSizeLabels.removeClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
      enableATCBtn()
    } else {
      // If not, no sizes are available for this color, remove all selections
      state.size = ''
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).val('')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-size-label]').removeClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
      disableATCBtn()
    }
  }

  function updateSelectedWeight() {
    let $newSelectedVariant = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).find(
      `option[data-option-1="${state.weight}"][data-option-2="${state.size}"]`
    )
    const variantAvailable = $newSelectedVariant.data('available')
    let price = $newSelectedVariant.data('variant-price')

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).text('$' + price)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).data('gip-original-value', price)

    // If the currently selected size is available in the new weight, this is fine and exit this function
    if (variantAvailable) {
      enableATCBtn()
    } else {
      disableATCBtn()
    }
  }

  function handleSleepyBagSizeChange() {
    // Update state
    state.size = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val()
    const $registryButton = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-hook="add-to-registry"]')
    const $registryText = $registryButton.find('[data-registry-atc-text]')

    // Add active state to element
    const $parentLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent('.pdp-variant-select-label')
    $parentLabel.addClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')

    // Remove active state from old element
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-size-label]')
      .not($parentLabel)
      .removeClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')

    $registryButton.removeClass('cursor-not-allowed').attr('disabled', false)
    $registryText.text('Add to Registry')

    updateSelectedWeight()
    updateSleepyBagVariant()
    updateProductMaxQty()
  }

  function enableATCBtn() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToCartBtn).attr('disabled', false).removeClass('btn-disabled').text('Add to Cart')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.quantityInputContainer).removeClass('max-w-0 opacity-0').addClass('flex max-w-full opacity-1')
    handleProductDiscountPriceChange()
  }

  function disableATCBtn() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToCartBtn).attr('disabled', true).addClass('btn-disabled').text('Out of Stock')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.quantityInputContainer).addClass('max-w-0 opacity-0').removeClass('flex max-w-full opacity-1')
  }

  function updateSleepyBagVariant() {
    const $activeNode = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).find(
      `option[data-option-1="${state.weight}"][data-option-2="${state.size}"]`
    )
    state.selectedVariant = $activeNode.val()
    const price = $activeNode.data('variant-price')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).text(`$${price}`)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).data('gip-original-value', price)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).val(state.selectedVariant)
  }

  function handleSizeChange() {
    state.size = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val()

    const $parentLabel = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent('.pdp-variant-select-label')
    $parentLabel.addClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.pdp-variant-select-label')
      .not($parentLabel)
      .removeClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
    updateSelectedVariant()
  }

  function updateSelectedVariant() {
    const $activeNode = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).find(
      `option[data-option-1="${state.size}"][data-option-2="${state.color}"]`
    )
    state.selectedVariant = $activeNode.val()
    const price = $activeNode.data('variant-price')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).text(`$${price}`)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice).data('gip-original-value', price)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).val(state.selectedVariant)
  }

  function updateSizeSelectorAvailability() {
    const $hiddenSelect = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).find('option')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeRadios).each(function () {
      const $parentInput = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent('.pdp-variant-select-label')
      const size = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val()
      const inStock = $hiddenSelect
        .filter(`[data-option-1="${size}"][data-option-2="${state.color}"]`)
        .data('available')
      if (inStock) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).prop('disabled', false)
        $parentInput.removeClass('pdp-variant-select-label-disabled')
      } else if (!inStock) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).prop('disabled', true)
        $parentInput.addClass('pdp-variant-select-label-disabled')
      }
    })
  }

  function updateSizeSelectorAvailabilitySleepyBag() {
    const $hiddenSelect = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).find('option')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeRadios).each(function () {
      const $parentInput = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent('.pdp-variant-select-label')
      const size = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val()
      const inStock = $hiddenSelect
        .filter(`[data-option-1="${state.weight}"][data-option-2="${size}"]`)
        .data('available')

      if (inStock) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).prop('disabled', false)
        $parentInput.removeClass('pdp-variant-select-label-disabled')
      } else if (!inStock) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).prop('disabled', true)
        $parentInput.addClass('pdp-variant-select-label-disabled')
      }
    })
  }

  function updateWeightSelectorAvailability() {
    const $hiddenSelect = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).find('option')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.weightRadios).each(function () {
      const $parentInput = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent('.pdp-variant-select-label')
      const weight = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).val()
      const inStock = $hiddenSelect
        .filter(`[data-option-1="${weight}"][data-option-2="${state.size}"]`)
        .data('available')

      if (inStock) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).prop('disabled', false)
        $parentInput.removeClass('pdp-variant-select-label-disabled')
      } else if (!inStock) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).prop('disabled', true)
        $parentInput.addClass('pdp-variant-select-label-disabled')
      }
    })
  }

  const cipherKey = {
    D: '0',
    S: '1',
    U: '2',
    K: '3',
    O: '4',
    Y: '5',
    F: '6',
    C: '7',
    B: '8',
    I: '9',
  }

  function updateProductMaxQty() {
    const $qty = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-qty').not(':disabled')
    const variantId = $qty.data('variant-id')
    const globalMax = $qty.data('global-max')

    const cart = SlideCart.getState()
    const variantInCart = cart.items.filter((t) => t.variant_id === variantId)
    const qtyInCart = variantInCart.length === 0 ? 0 : variantInCart[0].quantity

    const $atcBtn = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToCartBtn)
    const productIsUnavailable = $atcBtn.data('product-unavailable')

    const baseMaxQty = $qty.data('home-good') ? 2 : globalMax
    const maxQty = baseMaxQty - qtyInCart
    $qty.attr('max', maxQty)

    if (!variantInCart.length || productIsUnavailable) return

    if (maxQty === 0) {
      $atcBtn.addClass('btn-disabled').text('Max Qty in Cart').attr('disabled', true)
    } else {
      enableATCBtn()
    }
  }

  function handleModalSizeChange(e) {
    const id = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('variant-id')
    const $label = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent()

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).prop('disabled') === false) {
      $label.siblings().removeClass('variant-select-label-active')
      $label.addClass('variant-select-label-active')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATCHiddenSelect).val(id).change()
    }
  }

  function revealStickyATCModal(e) {
    e && e.preventDefault()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATCModal).removeClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATCOverlay).removeClass('hidden')
  }

  function closeStickyATCModal(e) {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATCModal).addClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATCOverlay).addClass('hidden')
  }

  function toggleStickyATC() {
    const triggerHeight = 1100
    const scrollTop = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop()
    const windowHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).height()
    const docHeight = jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).height()
    const isAtBottom = scrollTop + windowHeight >= docHeight - 50

    if (isAtBottom) {
      // Remove sticky ATC when at the bottom of the page
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATC).removeClass('!bottom-0')
    } else if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATC).hasClass('!bottom-0') && scrollTop >= triggerHeight) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATC).addClass('!bottom-0')
    } else if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATC).hasClass('!bottom-0') && scrollTop < triggerHeight) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyATC).removeClass('!bottom-0')
    }
  }

  function revealSizeChartModal(e) {
    e.preventDefault()
    // Try to find the modal as a sibling first, then look in the closest container
    let modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget).siblings(settings.sizeChartModal)
    if (modal.length === 0) {
      modal = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget).closest('div').find(settings.sizeChartModal)
    }
    modal.removeClass('hidden')
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_3__.trapFocus)(settings.sizeChartModal)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
  }

  function hideSizeChartModal(e) {
    e.preventDefault()
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeChartModal).addClass('hidden')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.sizeChartModal).off('keydown')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  function toggleAccordion(e) {
    e.stopImmediatePropagation()
    const $button = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const $container = $button.parents(settings.accordionContainers)
    const $accordionContent = $container.find('[data-accordion-content-container]')
    const $verticalLine = $container.find('[data-pdp-accordion-vertical-line]')

    if ($button.hasClass('accordion-open')) {
      // Close the accordion
      $verticalLine.removeClass('hidden')
      $button.removeClass('accordion-open !font-semibold').attr('aria-expanded', 'false')
      $accordionContent.removeClass('mb-6').slideUp()
    } else {
      // Open the accordion
      $verticalLine.addClass('hidden')
      $button.addClass('accordion-open !font-semibold').attr('aria-expanded', 'true')
      $accordionContent.addClass('mb-6').slideDown()
    }
  }

  function handleProductSubmit() {
    const $input = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.quantityInput)
    $input.val(1)
    setSelectedQuantity(1)
  }

  function decryptCipheredQuantity() {
    const cipheredQuantity = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).find(`option[value='${selectedVariantId()}']`).data('inventory')
    let availableQuantityString = ''

    cipheredQuantity.split('').forEach((char) => {
      const decryptedCharacter = cipherKey[char]
      availableQuantityString = availableQuantityString + decryptedCharacter
    })
    return parseInt(availableQuantityString)
  }

  async function changeItemQuantity(e) {
    e.preventDefault()
    const cart = SlideCart.getState()
    const $input = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.quantityInput)
    const maxQuantity = parseInt($input.attr('max'))
    const variantInCart = cart.items.filter((t) => t.variant_id === selectedVariantId())
    let existingQuantity = 0

    if (variantInCart.length) {
      existingQuantity = variantInCart[0].quantity
    }

    const availableQuantity = decryptCipheredQuantity()

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('plus') && selectedQuantity() < maxQuantity && selectedQuantity() < availableQuantity) {
      $input.val(selectedQuantity() + 1)
    } else if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('minus') && selectedQuantity() > 1) {
      $input.val(selectedQuantity() - 1)
    }

    setSelectedQuantity(parseInt($input.val()))
  }

  function changeSelectedVariant(e) {
    const id = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('variant-id')
    const price = (0,_utilities__WEBPACK_IMPORTED_MODULE_3__.formatMoney)(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('price'))
    const compareAtPrice = (0,_utilities__WEBPACK_IMPORTED_MODULE_3__.formatMoney)(jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).data('compare-at-price'))
    const $label = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).parent()
    const activeSizeName = $label.data('size-variant-button')
    const activeSizeTextNode = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.selectedSizeText)
    const $registryButton = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-hook="add-to-registry"]')
    const $registryText = $registryButton.find('[data-registry-atc-text]')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-qty').data('variant-id', id)
    setSelectedVariantId(id)
    activeSizeTextNode.html(`Size: <span>${activeSizeName}</span>`)
    $registryButton.removeClass('cursor-not-allowed').attr('disabled', false)
    $registryText.text('Add to Registry')

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpUpsellSizeSelect).length && jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpUpsellSizeSelect).val() === null) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpUpsellSizeSelect).find(`option[data-upsell-size-option="${activeSizeName}"]`).prop('selected', true)
    }

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).prop('disabled') === false) {
      const $atcBtn = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToCartBtn)
      $atcBtn.removeClass('btn-disabled').text('Add to Cart').attr('disabled', false)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.quantityInputContainer).removeClass('max-w-0 opacity-0').addClass('flex max-w-full opacity-1')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.gwButtonContainer).removeClass('hidden')

      $label.addClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
      $label.siblings().removeClass('pdp-variant-select-label-active holiday-pdp-variant-select-label-active')
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.hiddenSelect).val(id).change()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-compare-at-price').html(compareAtPrice)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-price').html(price)
      handleProductDiscountPriceChange()
    }

    updateProductMaxQty()
  }

  function handleVariantKeydown(e) {
    // Handle Enter and Space key presses for variant selection
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      // If this is a label, find and trigger the radio input
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).hasClass('pdp-variant-select-label')) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).find('input[type="radio"]').trigger('click')
      } else {
        // If this is already a radio input, trigger click
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).trigger('click')
      }
    }
  }

  let modalOne = null
  let modalOneContent = null
  let modalTwo = null
  let modalTwoContent = null
  let shopTheLookSlider = null

  function initModalOnes() {
    const modalOneBtns = document.querySelectorAll('[data-js-open-look-modal-btn]')
    const modalOneCloseBtns = document.querySelectorAll('[data-js-close-look-modal-btn]')
    modalOneBtns.forEach((btn) => {
      const lookModalIndex = parseInt(btn.dataset.lookIndex)

      if (isNaN(lookModalIndex)) return
      btn.addEventListener('click', () => openModalOne(lookModalIndex))
    })
    modalOneCloseBtns.forEach((btn) => {
      btn.addEventListener('click', closeModalOne)
    })
  }
  function openModalOne(index = 0) {
    shopTheLookSlider = document.querySelector('[data-js-shop-the-look-slider]')
    modalOne = document.querySelector(`[data-look-modal-index="${index}"]`)
    if (!modalOne) return
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_3__.disableScroll)()

    modalOne.classList.remove('hidden')
    modalOneContent = modalOne.querySelector('[data-js-modal-content]')
    // trigger reflow
    const reflow = modalOneContent.offsetHeight
    modalOneContent.classList.add('on')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
  }

  function closeModalOne() {
    if (!modalOne || !modalOneContent) return
    modalOneContent.classList.remove('on')
    modalOneContent.addEventListener(
      'transitionend',
      () => {
        modalOne.classList.add('hidden')
        ;(0,_utilities__WEBPACK_IMPORTED_MODULE_3__.enableScroll)()
        modalOne = null
        modalOneContent = null
      },
      { once: true }
    )
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  function initModalTwos() {
    // const modalTwoBtns = document.querySelectorAll('[data-js-open-quick-buy-btn]')
    // const modalTwoCloseBtns = document.querySelectorAll('[data-js-close-quick-buy-btn]')
    // const modalTwoCloseAllBtns = document.querySelectorAll('[data-js-close-shop-look-btn]')

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '[data-js-open-quick-buy-btn]', function () {
      const quickBuyModalIndex = this.dataset.quickBuyIndex
      openModalTwo(quickBuyModalIndex)
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '[data-js-close-quick-buy-btn]', closeModalTwo)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '[data-js-close-shop-look-btn]', closeAllModals)
  }

  function openModalTwo(quickBuyModalIndex) {
    modalTwo = document.querySelector(`[data-quick-buy-modal--index="${quickBuyModalIndex}"]`)

    // if (!modalOne) return
    ;(0,_utilities__WEBPACK_IMPORTED_MODULE_3__.disableScroll)()
    modalTwo.classList.remove('hidden')
    modalTwoContent = modalTwo.querySelector('[data-js-modal-content]')
    const slickContainers = modalTwo.querySelectorAll('[data-slick]')

    // trigger reflow
    const reflow = modalOneContent && modalOneContent.offsetHeight

    if (!slickContainers) return
    slickContainers.forEach((slickContainer) => {
      slickContainer.slick.refresh()
      slickContainer.slick.slickGoTo(0, false)
    })
    modalTwoContent.classList.add('on')
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
  }

  function closeModalTwo() {
    if (!modalTwo || !modalTwoContent) return
    modalTwoContent.classList.remove('on')
    modalTwoContent.addEventListener(
      'transitionend',
      () => {
        modalTwo.classList.add('hidden')
        ;(0,_utilities__WEBPACK_IMPORTED_MODULE_3__.enableScroll)()
        modalTwo = null
        modalTwoContent = null
      },
      { once: true }
    )
    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }

  function closeAllModals() {
    closeModalOne()
    closeModalTwo()
  }

  function initModalClosingEvents() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '[data-js-close-modal-screen]', function (event) {
      if (event.target === this) closeAllModals()
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', '[data-js-add-to-cart]', function (event) {
      if (event.target === this) closeAllModals()
    })

    document.addEventListener('keydown', (event) => {
      if (event.key == 'Escape') {
        closeAllModals()
      }
    })
  }

  const trapFocusInElement = (selector) => {
    var $focusableElements = jquery__WEBPACK_IMPORTED_MODULE_0___default()(selector)
      .find(
        'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]'
      )
      .filter(':visible')
    var $firstFocusableElement = $focusableElements.first()
    var $lastFocusableElement = $focusableElements.last()

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(selector).on('keydown', function (e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          /* shift + tab */ if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.activeElement).is($firstFocusableElement)) {
            e.preventDefault()
            $lastFocusableElement.focus()
          }
        } /* tab */ else {
          if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.activeElement).is($lastFocusableElement)) {
            e.preventDefault()
            $firstFocusableElement.focus()
          }
        }
      }
    })
  }

  function handleProductDiscountPriceChange() {
    const $checkboxes = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpUpsellAddCheckbox)
    // const $discountBadge = $(settings.pdpUpsellDiscountBadge)
    const $discountPrice = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.pdpUpsellDiscountPrice)
    const $productPrice = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.productPrice)

    // Check if any checkbox is checked
    const anyChecked = $checkboxes.toArray().some((checkbox) => jquery__WEBPACK_IMPORTED_MODULE_0___default()(checkbox).is(':checked'))

    if (anyChecked) {
      // Remove 'hidden' class from discount elements and add 'line-through' to product price
      // $discountBadge.removeClass('hidden').addClass('flex')
      $discountPrice.removeClass('hidden')
      $productPrice.addClass('line-through')
      if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToCartBtn).hasClass('btn-disabled')) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToCartBtn).text('Add Set to Cart')
      }
    } else {
      // Add 'hidden' class to discount elements and remove 'line-through' from product price
      // $discountBadge.addClass('hidden').removeClass('flex')
      $discountPrice.addClass('hidden')
      $productPrice.removeClass('line-through')
      if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToCartBtn).hasClass('btn-disabled')) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToCartBtn).text('Add to Cart')
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.addToCartBtn).text('Select Size')
      }
    }
  }

  initModalOnes()
  initModalTwos()
  initModalClosingEvents()

  return {
    updateProductMaxQty,
    setSelectedQuantity,
  }
}


/***/ }),

/***/ 4982:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ formatMoney)
/* harmony export */ });
function formatMoney(cents) {
  return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}


/***/ }),

/***/ 5383:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ clickToggle)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
 * @description
 * * Toggles the 'active' class on a given element on click
 * * Multiple triggers can toggle the active class on a single target
 *
 * @options HTML data properties on "wrapper" element
 * * [data-utility="click-toggle"] { required } - Wrapper element that runs this code
 * * [data-toggle] {required} - Pass query selector for target element
 * * [data-toggle-scroll] {optional} - Pass true to toggle scroll on the target element
 * * [data-handle-document-click] {optional} - Pass true to handle document click outside the wrapper
 */

function clickToggle({ wrapper }) {
  const selectors = {
    target: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle'),
    triggers: `[data-toggle="${jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle')}"]`,
    toggleScroll: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('toggle-scroll'),
    handleDocumentClick: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('handle-document-click'),
  }

  const cache = {
    $targets: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.target),
    $triggers: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.triggers).not(wrapper).add(wrapper),
  }

  // TailwindCSS variants representing different states
  const { classes } = window.config

  ;(function initEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click.clickToggle.toggle', toggle)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('toggle:close', close)
    if (selectors.handleDocumentClick === true) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', handleDocumentClick)
    }
  })()

  function handleDocumentClick(event) {
    const $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target)

    // Only close if the click is outside the wrapper
    if (selectors.handleDocumentClick === true && !$target.closest(wrapper).length) {
      close()
    }
  }

  function toggle() {
    const isActive = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).hasClass(classes.active)

    cache.$targets.toggleClass(classes.active, !isActive)
    cache.$triggers.toggleClass(classes.active, !isActive)

    if (selectors.toggleScroll === true) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').toggleClass('no-scroll')
    }
  }

  function close() {
    cache.$targets.removeClass(classes.active)
    cache.$triggers.removeClass(classes.active)
  }
}


/***/ }),

/***/ 7065:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ toggleButtonState)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function toggleButtonState($button, activeClass, text) {
  $button
    .toggleClass(`${activeClass} btn-disabled-new`)
    .text(text)
    .prop('disabled', function (i, v) {
      return !v
    })
}


/***/ }),

/***/ 8569:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ enableScroll)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function enableScroll() {
  jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).removeClass('overflow-hidden')
  jquery__WEBPACK_IMPORTED_MODULE_0___default()('html').removeClass('overflow-hidden')
}


/***/ }),

/***/ 9822:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   clickToggle: () => (/* reexport safe */ _click_toggle__WEBPACK_IMPORTED_MODULE_0__["default"]),
/* harmony export */   disableScroll: () => (/* reexport safe */ _disable_scroll__WEBPACK_IMPORTED_MODULE_5__["default"]),
/* harmony export */   elementsExist: () => (/* reexport safe */ _elements_exist__WEBPACK_IMPORTED_MODULE_1__["default"]),
/* harmony export */   enableScroll: () => (/* reexport safe */ _enable_scroll__WEBPACK_IMPORTED_MODULE_6__["default"]),
/* harmony export */   formatMoney: () => (/* reexport safe */ _format_money__WEBPACK_IMPORTED_MODULE_2__["default"]),
/* harmony export */   showToastNotification: () => (/* reexport safe */ _show_toast_notification__WEBPACK_IMPORTED_MODULE_8__["default"]),
/* harmony export */   toggleButtonState: () => (/* reexport safe */ _toggle_button_state__WEBPACK_IMPORTED_MODULE_7__["default"]),
/* harmony export */   trapFocus: () => (/* reexport safe */ _trap_focus__WEBPACK_IMPORTED_MODULE_4__["default"]),
/* harmony export */   useState: () => (/* reexport safe */ _use_state__WEBPACK_IMPORTED_MODULE_3__["default"])
/* harmony export */ });
/* harmony import */ var _click_toggle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5383);
/* harmony import */ var _elements_exist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(935);
/* harmony import */ var _format_money__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4982);
/* harmony import */ var _use_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2773);
/* harmony import */ var _trap_focus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2362);
/* harmony import */ var _disable_scroll__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1550);
/* harmony import */ var _enable_scroll__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8569);
/* harmony import */ var _toggle_button_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7065);
/* harmony import */ var _show_toast_notification__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2303);













/***/ })

}]);